import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TID } from "@/constants/testIds";
import { Reveal } from "./Reveal";

const TRUST = ["14 dias de teste grátis", "Sem fidelidade contratual", "Suporte especializado em food service", "Relatórios em 1 clique"];

export function FinalCta() {
  return (
    <section data-testid="landing-final-cta" className="relative bg-stone-950 text-white py-24 overflow-hidden">
      <div className="absolute inset-x-0 -top-32 h-64 bg-emerald-700/10 blur-3xl" aria-hidden />
      <Reveal className="relative max-w-6xl mx-auto px-6 lg:px-8 grid grid-cols-[minmax(0,1fr)] lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.02]">
            Sua cozinha operando com precisão de alta gastronomia.
          </h2>
          <p className="mt-5 font-body text-base md:text-lg text-stone-400 max-w-2xl">
            Checklists com prova, ponto sem fraude e estoque sem furo — em uma plataforma que a equipe realmente usa.
          </p>
          <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-2 text-sm text-stone-300 font-body">
            {TRUST.map((t) => (
              <li key={t} className="inline-flex items-center gap-2">
                <CheckCircle2 className="h-4 w-4 text-emerald-400 shrink-0" /> {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-4 flex flex-col gap-3">
          <Link to="/register" className="w-full">
            <Button className="w-full bg-emerald-500 hover:bg-emerald-400 text-stone-950 font-body px-8 h-13 py-4 rounded-lg font-semibold text-base" data-testid="cta-bottom-primary">
              Criar conta grátis agora <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/pricing" className="w-full">
            <Button variant="outline" className="w-full border-stone-700 bg-stone-900 hover:bg-stone-800 text-white font-body px-8 h-13 py-4 rounded-lg text-base" data-testid="cta-bottom-secondary">
              Conhecer os planos
            </Button>
          </Link>
        </div>
      </Reveal>
    </section>
  );
}

export function LandingFooter() {
  return (
    <footer data-testid={TID.landingFooter} className="bg-stone-950 text-stone-500 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <img src="/logo.png" alt="Ultra" className="h-8 w-8 rounded-lg" />
          <div>
            <div className="font-display font-extrabold text-white leading-none">Ultra</div>
            <div className="text-[9px] font-bold tracking-[0.25em] text-emerald-400 uppercase mt-0.5">Cozinha organizada</div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs font-body">
          <a href="#checklists" className="hover:text-stone-200">Checklists</a>
          <a href="#ponto" className="hover:text-stone-200">Ponto</a>
          <a href="#estoque" className="hover:text-stone-200">Estoque</a>
          <a href="#roi" className="hover:text-stone-200">Calculadora ROI</a>
          <Link to="/pricing" className="hover:text-stone-200">Planos</Link>
          <Link to="/login" className="hover:text-stone-200">Entrar</Link>
          <Link to="/register" className="hover:text-stone-200">Trial gratuito</Link>
        </div>
        <div className="font-body text-xs">© {new Date().getFullYear()} Ultra. Cozinha organizada.</div>
      </div>
    </footer>
  );
}
